export enum VerzekeringenRoutesEnum {
    ArrangeImmediately = 'direct-regelen',
}
